import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import axios from "axios";
import { ViewerProvider } from "../../../providers/ViewerProvider";
import { AuthDataProvider } from "../../../providers/AuthDataProvider";
import { Viewer360Component } from "./Viewer360Component";
import { TranslationsProvider } from "../../../providers/TranslationsProvider";
import "react-lazy-load-image-component/src/effects/blur.css";
export var Viewer360 = function (props) {
    var token = props.token, language = props.language, defaultLanguage = props.defaultLanguage, siteId = props.siteId, apiBaseUrl = props.apiBaseUrl, staticSourceUrl = props.staticSourceUrl;
    useEffect(function () {
        axios.defaults.baseURL = apiBaseUrl;
    }, [apiBaseUrl]);
    return (_jsx(AuthDataProvider, __assign({ token: token, staticSourceUrl: staticSourceUrl }, { children: _jsx(TranslationsProvider, __assign({ language: language, defaultLanguage: defaultLanguage }, { children: _jsx(ViewerProvider, __assign({ siteId: siteId }, { children: _jsx(Viewer360Component, {}) })) })) })));
};
